module.exports = __webpack_public_path__ + "img/search.d1d41b76.png";